const EXTRA_COMPONENT_TYPE = {
  LinkToLESubsidiaries: 'LinkToLESubsidiaries',
  HeadcountTable: 'HeadcountTable',
};

export default EXTRA_COMPONENT_TYPE;
